import styles from './map-overlay-panel.module.css';

export interface MapOverlayPanelProps {
  children: React.ReactNode;
  className?: string;
}

export function MapOverlayPanel(props: MapOverlayPanelProps) {
  return (
    <div
      className={`${styles.panel} mapboxgl-ctrl ${props.className ?? ''}`.trim()}
    >
      {props.children}
    </div>
  );
}

export default MapOverlayPanel;
